module.exports = __webpack_public_path__ + "files/f04e442a570ba2ab39c741485f7ea457.png";